<template>
  <div>
    <b-modal @hide="hideModal(false)" :visible="show" :no-close-on-backdrop="loading" :no-close-on-esc="loading"
    :header-bg-variant="variant">
      <template v-slot:modal-header>
        <h5 class="modal-title" :style="titleStyle">
          {{ title }}
        </h5>
        <button type="button" :disabled="loading" @click="hideModal(false)" aria-label="Close" class="close">×
        </button>
      </template>
      <template v-slot:modal-footer>
        <cancel-button :text="cancelBtnText" :disabled="disableAllButtons" @click="hideModal(false)"/>
        <div v-if="extraHandlers">
          <submit-button v-for="extraHandler in extraHandlers" :key="extraHandler.submitBtnText" variant="danger"
                         :text="extraHandler.submitBtnText" :disabled="disableSubmitBtn"
                         :show-loader="extraHandlersLoading[extraHandler.submitBtnText]"
                         @click="onSubmitClick($event, extraHandler)"/>
        </div>
        <cancel-button v-if="thirdBtnText" :text="$t(thirdBtnText)" :disabled="disableAllButtons" @click="hideModal(thirdBtnText)"/>
        <submit-button variant="danger" :text="$t(submitBtnText)" :disabled="disableSubmitBtn" :show-loader="loading"
                       @click="onSubmitClick"/>
      </template>
      <span v-html="message"/>
      <span v-if="extraMessage" v-html="extraMessage.message" @click="onSubmitClick($event, extraMessage)"/>
      <div v-if="confirmationInputOptions" class="mt-4">
        <b-form-group class="mb-0">
          <label>
            {{ confirmationInputOptions.label }}
          </label>
          <b-form-input v-model="confirmationInputText" :placeholder="confirmationInputOptions.text"/>
        </b-form-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import CancelButton from "../../core/components/common/CancelButton";
  import SubmitButton from "../../core/components/common/SubmitButton";
  import EventBus from "../event-bus";
  import {ON_CONFIRM_DIALOG_HIDE, ON_CONFIRM_DIALOG_OPEN} from "../event-bus/event-bus-names";

  export default {
    name: "ConfirmModal",
    components: {SubmitButton, CancelButton},
    computed: {
      disableSubmitBtn() {
        if (this.confirmationInputOptions && this.confirmationInputOptions.text !== this.confirmationInputText) {
          return true
        }
        return this.disableAllButtons
      },
      disableAllButtons() {
        let extraHandlersLoading = false;
        if (this.extraHandlers) {
          extraHandlersLoading = this.extraHandlers.reduce((previousVal, currenVal) =>
              previousVal || this.extraHandlersLoading[currenVal.submitBtnText], false);
        }
        return extraHandlersLoading || this.loading;
      },
      titleStyle() {
        if (this.variant === 'danger') return {color: 'white'}
      }
    },
    data() {
      return {
        loading: false,
        show: false,
        message: null,
        successMessage: null,
        handler: null,
        handlerParams: null,
        title: null,
        submitBtnText: null,
        cancelBtnText: null,
        extraHandlers: null,
        extraHandlersLoading: {},
        confirmationInputOptions: null,
        confirmationInputText: null,
        extraMessage: null,
        variant: null,
        thirdBtnText: null
      }
    },
    methods: {
      getMessageHTML(message) {
        // If given message is array, convert it to Unordered List
        if (Array.isArray(message) && message.length > 0) {
          if (message.length === 1) {
            message = message[0]
          } else {
            let list = document.createElement('ul')
            message.forEach((s) => {
              let item = document.createElement('li')
              item.appendChild(document.createTextNode(s))
              list.appendChild(item)
            })
            return list.innerHTML
          }
        }
        return message
      },
      hideModal(param) {
        EventBus.$emit(ON_CONFIRM_DIALOG_HIDE, param);
        this.clearParams();
      },
      clearParams() {
        this.message = null;
        this.loading = false;
        this.successMessage = null;
        this.handler = null;
        this.handlerParams = null;
        this.title = null;
        this.show = false;
        this.submitBtnText = null;
        this.cancelBtnText = null;
        this.extraHandlers = null;
        this.confirmationInputOptions = null;
        this.confirmationInputText = null;
        this.extraMessage = null;
        this.variant = null;
        this.thirdBtnText = null;
      },
      async onSubmitClick(_, extraHandler) {
        if (this.handler || extraHandler) {
          const _handle = extraHandler || {
            successMessage: this.successMessage,
            handler: this.handler,
            handlerParams: this.handlerParams,
          };
          this.setLoading(_handle, true);
          let response = await _handle.handler(_handle.handlerParams);
          this.setLoading(_handle, false);
          if (response.success) {
            this.$toast('success', this.successMessage);
            this.hideModal(true);
          } else {
            if (response.toastError) {
              this.$errorDialog(response.toastError);
            } else {
              if (response.body && response.body.non_field_errors) {
                if (typeof response.body.non_field_errors === 'object' && response.body.non_field_errors.length > 1) {
                  const listItemsArr = [];
                  response.body.non_field_errors.forEach(err => listItemsArr.push(this.$createElement('li', {}, err)))
                  this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, listItemsArr), this.$i18n.t('Validation Error'));
                } else {
                  this.$errorDialog(response.body.non_field_errors[0]);
                }
              }
            }
            this.hideModal(false);
          }
        } else {
          this.hideModal(true);
        }
      },
      setLoading(handler, loading) {
        if (handler.submitBtnText) {
          this.extraHandlersLoading[handler.submitBtnText] = loading;
          this.extraHandlersLoading = {...this.extraHandlersLoading};
        } else {
          this.loading = loading;
        }
      }
    },
    beforeMount() {
      EventBus.$on(ON_CONFIRM_DIALOG_OPEN, ({
                                              message,
                                              successMessage,
                                              handler,
                                              handlerParams,
                                              title,
                                              submitBtnText,
                                              cancelBtnText,
                                              extraHandlers,
                                              confirmationInputOptions,
                                              extraMessage,
                                              variant,
                                              thirdBtnText
                                            }) => {
        this.clearParams();
        this.message = this.getMessageHTML(message);
        this.successMessage = successMessage;
        this.handler = handler;
        this.handlerParams = handlerParams;
        this.title = title;
        this.show = true;
        this.submitBtnText = submitBtnText;
        this.cancelBtnText = cancelBtnText;
        this.extraHandlers = extraHandlers;
        this.extraMessage = extraMessage;
        this.variant = variant
        this.thirdBtnText = thirdBtnText
        if (extraHandlers) {
          extraHandlers.forEach(eh => {
            this.extraHandlersLoading[eh.submitBtnText] = false;
          });
        }
        this.confirmationInputOptions = confirmationInputOptions
      });
    },
    beforeDestroy() {
      EventBus.$off(ON_CONFIRM_DIALOG_OPEN);
    }
  }
</script>

<style scoped>

</style>
